import { render, staticRenderFns } from "./LabLink.vue?vue&type=template&id=5cff9ccf&scoped=true"
import script from "./LabLink.vue?vue&type=script&lang=js"
export * from "./LabLink.vue?vue&type=script&lang=js"
import style0 from "./LabLink.vue?vue&type=style&index=0&id=5cff9ccf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cff9ccf",
  null
  
)

export default component.exports